import React from 'react'

import Box from '@mui/material/Box'

const L4LHeader = () => <Box className="icon l4l-small-icon tablet-portrait-up-only" />

export default L4LHeader
